"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const options_1 = require("../options");
function default_1() {
    const { getJWT } = (0, options_1.getOptions)();
    return getJWT();
}
exports.default = default_1;
